import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leadingZero'
})
export class LeadingZeroPipe implements PipeTransform {

  transform(value: number, totalLength: number = 3): string {
    if (value == null) return '';

    // Tarkista, pitäisikö numero muotoilla
    const maxAllowedLength = Math.pow(10, totalLength - 1); // Esim. 3 → 10^(3-1) = 100
    if (value < maxAllowedLength) {
      return value.toString().padStart(totalLength, '0');
    }

    // Jos numero on liian suuri, ei lisätä johtavia nollia
    return value.toString();
  }

}
